export enum MODIFIER_LIST_TYPE {
  MULTIPLE = "MULTIPLE",
  SINGLE = "SINGLE",
}

export enum DISCOUNT_TYPES {
  FIXED = "FIXED",
  PERCENTAGE = "PERCENTAGE",
}

export enum CHARGE_TYPES {
  FIXED = "FIXED",
  PERCENTAGE = "PERCENTAGE",
}

export enum TAXES_INCLUSION_TYPE {
  ADDITIVE = "ADDITIVE",
  INCLUSIVE = "INCLUSIVE",
}

export enum DISCOUNT_APPLIED_TO {
  ANY_ITEM = "ANY_ITEM",
  TOTAL_BILL = "TOTAL_BILL",
  SPECIFIC_CATEGORY = "SPECIFIC_CATEGORY",
  SPECIFIC_ITEM = "SPECIFIC_ITEM",
}

export enum MENU_STEPPER {
  BASIC_INFORMATION,
  SCHEDULE_DISCOUNT,
}

export enum SALES_OPTION_ICON {
  OTHER = "other",
  DELIVERY = "truck-delivery",
  DINE = "dine-in",
  PICKUP = "pick-up",
}
export enum SALES_OPTION_TYPE {
  OTHER = "OTHER",
  DELIVERY = "DELIVERY",
  DINE = "DINE",
  PICKUP = "PICKUP",
}

export enum PAYMENT_CATEGORY_TYPES {
  IN = "IN",
  OUT = "OUT"
}